<template>
<div class="chapter">
<div class="inner_page">
<div class="fbox">
<p class="ftoc"><b>PROJECT LEVELS</b></p>
<p class="ftoc"><img alt="" class="mid" src="images/p1.jpg"/> <b>Beginner</b></p>
<p class="ftoc"><img alt="" class="mid" src="images/p2.jpg"/> <b>Experienced Beginner</b></p>
<p class="ftoc"><img alt="" class="mid" src="images/p3.jpg"/> <b>Intermediate</b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?89d2a118